<template>
  <v-container
    text-center
    fluid
    mt-3>
    <v-layout
      wrap
      justify-center>
      <v-flex
        xs12
        sm10
        md8
        lg6
        xl4>
        <v-card class="py-5">
          <v-card-text class="mb-3">
            <div class="alert-color text-size-6">
              Sorry, Not Found ...
            </div>
          </v-card-text>
          <NotFoundIcon />
          <v-row
            no-gutters
            justify="center"
            class="mt-8 mb-5">
            <v-col
              cols="8"
              class="text-center">
              <v-btn
                color="secondary"
                to="/">
                ログインページへ
              </v-btn>
            </v-col>
          </v-row>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<style scoped>
.alert-color {
  color: grey;
}
</style>

<script>
import NotFoundIcon from '../components/SVGs/NotFoundIcon';

export default {
  components: {
    NotFoundIcon,
  },
  created: function() {
    this.$store.dispatch('initialLoginState', false);
  },
};
</script>
